
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
